import { Link } from 'react-router-dom'
import { easymarks } from '../../../assets'
import '../Project.css'

export default function EasyMarks() {

  window.scrollTo(0, 0)

  return (
    <>
      <div className='project-wrapper'>
        <div className="project-container">
          <div className='project-image-container'>
            <img src={easymarks} className='project-image'
            alt='Easy Marks' />
          </div>
          <div className='project-title'>
            <h1>Easy Marks</h1>
          </div>
          <div className='project-description'>
            <p>This project is designed to be a chrome extension that allows users to save their online bookmarks to a vector database where bookmarks can later be searched for by using embedding similarity search.</p>
          </div>
          <div className='project-links'>
            <Link to='https://www.easymarks.io/'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fas fa-external-link-alt'>&nbsp;</i>
              Deployment
            </Link>
            <Link to='https://github.com/labrocadabro/easy-marks'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fab fa-github' >&nbsp;</i>
              GitHub
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
